import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { css } from '@emotion/react';
import { akEditorLineHeight } from '@atlaskit/editor-shared-styles';
import { DN50, N30A } from '@atlaskit/theme/colors';
import { themed } from '@atlaskit/theme/components';
var divider = themed({
  light: "var(--ds-border, ".concat(N30A, ")"),
  dark: "var(--ds-border, ".concat(DN50, ")")
});

// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
export var ruleSharedStyles = function ruleSharedStyles(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & hr {\n    border: none;\n    background-color: ", ";\n    margin: ", "em 0;\n    height: 2px;\n    border-radius: 1px;\n  }\n"])), divider(props), akEditorLineHeight);
};